import React from "react";

import { useOrgSyntheticDataToggle } from "../../Hooks/useOrgSyntheticDataToggle";

export type SyntheticDataModeBannerProps = {
  /** Override default copy (e.g. Data Hub pipeline message). */
  message?: string;
  className?: string;
};

const SyntheticDataModeBanner: React.FC<SyntheticDataModeBannerProps> = ({
  message = "Synthetic Data Mode is enabled. KPIs and metrics displayed are based on sample data, not live production data.",
  className = "",
}) => {
  const { useSyntheticData } = useOrgSyntheticDataToggle();

  if (!useSyntheticData) {
    return null;
  }

  return (
    <div
      className={`rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 ${className}`}
      role="status"
    >
      {message}
    </div>
  );
};

export default SyntheticDataModeBanner;
